import { Controller } from "react-hook-form"
import { useRef } from "react"
import useOnClickOutside from "@/lib/hooks/useOnClickOutside"
import { Caret } from "@/common/icons/caret"
import classNames from "classnames"
import styles from "./select-control.module.css"

export const SelectControl = ({
  className,
  control,
  hierarchical = false,
  isOpen,
  label,
  name,
  onSelect,
  options,
  setOpen
}) => {
  const elemRef = useRef(null)
  useOnClickOutside(elemRef, () => setOpen(name), isOpen)

  return (
    <Controller
      {...{ control, name }}
      render={({ field }) => {
        const currentChoice =
          options.find((option) => option.value === field.value)?.label ||
          "Välj..."

        return (
          <div
            className={classNames(styles.controller, className, {
              "is-open": isOpen,
              "is-hierarchical": hierarchical
            })}
            ref={elemRef}>
            <div
              className={classNames({
                radios: true,
                "has-shadow": isOpen
              })}>
              <header onClick={() => setOpen(name)}>
                <div className="current-choice">
                  <span>{label}</span>
                  {currentChoice}
                </div>
                <Caret />
              </header>
              {isOpen && (
                <div className="open-filter">
                  <div className="overlay"></div>
                  <ul>
                    {options.length > 0 &&
                      options.map((option) => {
                        return (
                          <li
                            className="radio-wrapper"
                            key={option.value}
                            onClick={() => {
                              onSelect(name, option.value)
                            }}>
                            <label>
                              {option.label}
                              <input
                                type="radio"
                                name={name}
                                value={option.value}
                                defaultChecked={option.value === field.value}
                              />
                            </label>
                          </li>
                        )
                      })}
                  </ul>
                </div>
              )}
            </div>
          </div>
        )
      }}
    />
  )
}
